// components/CookieBanner.jsx — GDPR compliant cookie consent banner
import { useState, useEffect } from "react";

const COOKIE_KEY = "webstudio_cookie_consent";

export default function CookieBanner({ dark }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(COOKIE_KEY);
      if (!saved) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(COOKIE_KEY, "accepted"); } catch {}
    setVisible(false);
  };

  const decline = () => {
    try { localStorage.setItem(COOKIE_KEY, "declined"); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 px-4 py-4 transition-all duration-500 ${
        dark ? "bg-[#0F172A]/95 border-t border-white/10" : "bg-white/95 border-t border-[#E2E8F0]"
      }`}
      style={{ backdropFilter: "blur(12px)" }}
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        {/* Icon + Text */}
        <div className="flex items-start gap-3 flex-1">
          <span className="text-xl shrink-0 mt-0.5">🍪</span>
          <div>
            <p className={`text-sm font-semibold mb-0.5 ${dark ? "text-white" : "text-[#0F172A]"}`}>
              We use cookies
            </p>
            <p className={`text-xs leading-relaxed ${dark ? "text-white/50" : "text-[#0F172A]/50"}`}>
              This website uses cookies to improve your experience and analyze site traffic.
              By clicking "Accept", you consent to our use of cookies in accordance with GDPR.{" "}
              <a
                href="/privacy"
                className="text-[#A3E635] hover:underline"
              >
                Privacy Policy
              </a>
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex items-center gap-3 shrink-0 w-full sm:w-auto">
          <button
            onClick={decline}
            className={`flex-1 sm:flex-none text-xs font-semibold px-4 py-2.5 rounded-xl border transition-colors ${
              dark
                ? "border-white/20 text-white/60 hover:border-white/40 hover:text-white"
                : "border-[#E2E8F0] text-[#0F172A]/50 hover:border-[#0F172A]/30 hover:text-[#0F172A]"
            }`}
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="flex-1 sm:flex-none text-xs font-semibold px-5 py-2.5 rounded-xl bg-[#A3E635] text-[#0F172A] hover:bg-[#b5f23d] transition-colors"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
